
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class PartnerClientWriterService {

   public static addDsaClientDraft(
           axiosInstance: AxiosInstance, input: ServerData.PartnerClientWebWriter.AddDsaClientDraft$Input,
           f: (output: ServerData.PartnerClientWebWriter.AddDsaClientDraft$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'partnerclientappapi/partnerclient/add-dsa-client-draft',
            input.toJson()
        ).then((response) => ServerData.PartnerClientWebWriter.AddDsaClientDraft$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static sendDsaCustomerOnboardingLinkToCustomer(
           axiosInstance: AxiosInstance, input: ServerData.PartnerClientWebWriter.SendDsaCustomerOnboardingLinkToCustomer$Input,
           f: (output: string) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'partnerclientappapi/partnerclient/send-dsa-customer-onboarding-link-to-customer',
            input.toJson()
        ).then((response) => response.data as string)
       .then((output) => f(output))
       .catch(theEh);
   }


   public static generateAttributionCode(
           axiosInstance: AxiosInstance, input: ServerData.PartnerClientWebWriter.GenerateAttributionCode$Input,
           f: (output: ServerData.PartnerClientWebWriter.GenerateAttributionCode$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'partnerclientappapi/partnerclient/generate-attribution-code',
            input.toJson()
        ).then((response) => ServerData.PartnerClientWebWriter.GenerateAttributionCode$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

